import React from 'react'
import { ReactComponent as Icon } from 'src/Resources/Images/LiveView/AlternativeView/ai360.svg'

export const Ai360LabelIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <Icon viewBox="0 0 145.778 135.111" {...props} />
}
